import {
    activeSplits,
    baseUrl,
    currentAgent,
    deviceInformation,
    ident,
    route,
    ssoInformation,
} from './getConfigFromBackend';
import { getCurrentRelease } from './getCurrentRelease';

export const collectTagData = {
    environment: deviceInformation?.environment,
    mainDomain: deviceInformation?.mainDomain,
    deviceOutput: deviceInformation?.deviceOutput,
    deviceType: deviceInformation?.deviceType,
    release: getCurrentRelease(),
    currentAgent: currentAgent,
    baseUrl: baseUrl,
    route: route,
    loginStateOnLoad: ssoInformation?.loginStatus,
    userSession: ident,
    isGoldClub: ssoInformation.goldClub,
    browserLanguage: navigator.language,
    activeSplits: `${activeSplits.map(
        (split) => `${split.id}_${split.variation}`
    )}`,
};
